import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HideSpinnerGuard {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!route.queryParams['provider']) {
      const spinner = this.document.getElementById('pre-loading-spinner');
      if (spinner) spinner.style.display = 'none';
    }
    return true;
  }
}
